// @flow
import React, { Fragment } from 'react';
import { Route } from 'react-router';

import SocketConnector from '../../socketConnector';
import Clock from '../../Clock';
import Navbar from '../../Navbar';
import FlashMessages from '../../FlashMessages';
import BannerMessages from '../../TemporalBanner';
import MapView from '../MapView';
import BackendView from '../BackendView';
import ChangeRequestSuccessView from '../ChangeRequestSuccessView';
import ZendeskChat from '../../ZendeskChat';

import styles from './adminView.css';


const AdminView = () => (
  <Fragment>
    <SocketConnector />
    <Clock interval={10000} />
    <BannerMessages />
    <FlashMessages />
    <ZendeskChat />
    <div className={styles.adminViewport}>
      <Navbar />
      <Route path="/admin/map" component={MapView} />
      <Route path="/admin/backend" component={BackendView} />
      <Route path="/success-approval" component={ChangeRequestSuccessView} />
    </div>
  </Fragment>
);


export default AdminView;



// WEBPACK FOOTER //
// ./src/scripts/components/views/AdminView/index.jsx